// SoftPull MFE Modal Events

const targetElementId = '#softpull-plugin-events';
const softPullOpenEvent = 'softpull|modal|open';
const softPullSubmitEvent = 'softpull|modal|submitted';
const softPullCloseEvent = 'softpull|modal|close';

export const openSoftPullModal = (softPullEventDetails = {}) => {
  document.querySelector(targetElementId)?.dispatchEvent(
    new CustomEvent(softPullOpenEvent, {
      detail: softPullEventDetails
    })
  );
};

export const closeSoftPullModal = (softPullEventDetails = {}) => {
  document.querySelector(targetElementId)?.dispatchEvent(
    new CustomEvent(softPullCloseEvent, {
      detail: softPullEventDetails
    })
  );
};

export const attachSoftPullModalSubmittedEvent = (callback: EventListener) => {
  const eventTargetElement = document.querySelector(targetElementId);
  if (eventTargetElement) {
    eventTargetElement.addEventListener(softPullSubmitEvent, callback);
  }
};
export const removeSoftPullModalSubmittedEvent = (callback: EventListener) => {
  const eventTargetElement = document.querySelector(targetElementId);
  if (eventTargetElement) {
    eventTargetElement.removeEventListener(softPullSubmitEvent, callback);
  }
};
